const ADMIN_SEGMENT = ["a", "d", "m", "i", "n"].join("");

export const ADMIN_BASE_PATH = `/${ADMIN_SEGMENT}`;
export const ADMIN_LOGIN_PATH = `${ADMIN_BASE_PATH}/login`;
export const ADMIN_WILDCARD_PATH = `${ADMIN_BASE_PATH}/*`;
export const ADMIN_AUTH_API_BASE = `/api/${ADMIN_SEGMENT}/auth`;
